
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TicketsModule } from '@/store/modules/tickets'
import { IssuesModule } from '@/store/modules/issues'
import { ORDERAPI } from '@/api/orders'
import { getuserCurrentApp } from '@/utils/cookies'

// eslint-disable-next-line @typescript-eslint/interface-name-prefix
interface IFormdata {
  reason: string;
}

const defaultRole: IFormdata = {
  reason: ''
}

@Component({
  name: 'PendingDialog',
  components: {}
})
export default class extends Vue {
  private pendingDialog = Object.assign({}, defaultRole)
  private rules = {
    reason: [{ required: true, message: '请选择挂起原因', trigger: 'change' }]
  }

  private btnLoading = false
  private pendingReasonOptions = []

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get dialogVisible() {
    console.log('TicketsModule.pendingDialog', TicketsModule.pendingDialog)
    return TicketsModule.pendingDialog
  }

  get currentTicket() {
    return TicketsModule.currentTicket
  }

  @Watch('dialogVisible')
  private onDialogStatusChange(value: boolean) {
    console.log('value', value)
    if (value) { // 打开弹框
      // 调用受理人接口
      IssuesModule.SetHandler(this.userCurrentApp)
      this.pendingDialog = Object.assign({}, defaultRole)
      this.$nextTick(() => {
        if (this.$refs['forwardDialog']) {
          (this.$refs['forwardDialog'] as any).clearValidate()
        }
      })
      this.getPendingReasons()
    }
  }

  // 获取待转接群组数据
  private getPendingReasons() {
    ORDERAPI.getPendingReason({
      app_id: this.userCurrentApp
    }).then(res => {
      if (res.stat === 1) {
        this.pendingReasonOptions = res.data
      }
    }).catch(_ => {
      console.log('no data error')
    })
  }

  // 关闭弹框
  private handleClose() {
    TicketsModule.ToggleDialogStatus({
      name: 'pendingDialog',
      value: false
    })
  }

  private handlePendingSubmit() {
    const form: any = this.$refs['pendingDialog']
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.btnLoading = true
        ORDERAPI.pendingTicket({
          tid: this.currentTicket.tid,
          reason: this.pendingDialog.reason,
          t_type: this.currentTicket.ticket_type
        }, {
          app_id: this.userCurrentApp
        }).then(res => {
          if (res.stat === 1) {
            this.btnLoading = false
            this.$emit('handleSuccess', res)
            this.handleClose()
          }
        }).catch(_ => {
          this.btnLoading = false
        })
      }
    })
  }
}
